let state = {
  show_loading: false,
  selectedGlobalClient: null,
};

export default state;
